var RedirectFragmentFields;
(function (RedirectFragmentFields) {
    RedirectFragmentFields["StitchError"] = "_stitch_error";
    RedirectFragmentFields["State"] = "_stitch_state";
    RedirectFragmentFields["UserAuth"] = "_stitch_ua";
    RedirectFragmentFields["LinkUser"] = "_stitch_link_user";
    RedirectFragmentFields["StitchLink"] = "_stitch_link";
    RedirectFragmentFields["ClientAppId"] = "_stitch_client_app_id";
})(RedirectFragmentFields || (RedirectFragmentFields = {}));
export default RedirectFragmentFields;
//# sourceMappingURL=RedirectFragmentFields.js.map